/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { dayWiseCardCollectionListAction } from "../../../redux/action-creators/cardCollectionActionCreator";

class CardDayWiseList extends React.Component {
  constructor(props) {
    super(props);

    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      content: [],
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      selected: [],
      sortBy: "",
    };
    this.cardDayWiseGetList = this.cardDayWiseGetList.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.cardDayWiseGetList();
  }

  componentDidUpdate(prevProps) {
    const { cityFilter, operatorFilter, selectedDateFilter } = this.props;
    if (
      (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
      || (prevProps && prevProps.selectedDateFilter !== selectedDateFilter)
    ) {
      this.cardDayWiseGetList();
    }
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.cardDayWiseGetList();
      }
    });
  };

  // eslint-disable-next-line class-methods-use-this
  handleAction() {
    console.log("action clicked");
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.cardDayWiseGetList();
      },
    );
  }

  //   componentWillUnmount() {
  //     this.mounted = false;
  //   }

  /**
   * API call to get devices.
   * @param pageNo current page number
   */
  cardDayWiseGetList() {
    const {
      fetchDayWiseCardCollection, operatorFilter, cityFilter, selectedDateFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    fetchDayWiseCardCollection({
      pageNo,
      pageSize: rowsPerPage,
      operatorFilter,
      cityFilter,
      dateFilter: selectedDateFilter,
      sortBy,
    });
  }

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="date"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateStrings.dayWiseCardCollection}
          selectionAllowed={false}
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.CardCollection
        && state.CardCollection.dayWiseCardCollection
        && state.CardCollection.dayWiseCardCollection.data)
      || [],
    totalItems:
      (state
        && state.CardCollection
        && state.CardCollection.dayWiseCardCollection
        && state.CardCollection.dayWiseCardCollection.totalItems)
      || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchDayWiseCardCollection: (params) => {
    dispatch(dayWiseCardCollectionListAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CardDayWiseList);
